import { render, staticRenderFns } from "./PostingsReporting.vue?vue&type=template&id=5559b415&"
import script from "./PostingsReporting.vue?vue&type=script&lang=js&"
export * from "./PostingsReporting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports